module.exports = "//static.hsappstatic.net/LoginUI/static-1.15179/img/HubSpot.svg"